import {Order} from '../../types';
import {deliveryDateTypes} from '../../static_data/deliveryDateTypes';

export function isWeekDelivery(order: Order): boolean {
    if (order.deliveryDateType === deliveryDateTypes.WEEK.key && order.deliveryDate) {
        return true;
    }
    return false;
}
